// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1EhFE","modalForm":"UpgradeEpcsModal_modalForm__Yzy-J","modalFooter":"UpgradeEpcsModal_modalFooter__3bBYw"};